import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LightboxComponent} from './lightbox.component';
import {GalleryService} from '../gallery.service';
import {SelectorModule} from './selector/selector.module';
import {ImageModule} from '../../image/image.module';
import {HammerModule} from '@angular/platform-browser';

@NgModule({
  declarations: [LightboxComponent],
  imports: [
    CommonModule,
    SelectorModule,
    ImageModule,
    HammerModule
  ],
  exports: [
    LightboxComponent
  ],
  providers: [
    GalleryService
  ]
})
export class LightboxModule {
}
